<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 5" :key="n" cols="12">
        <v-sheet class="mt-2">
          <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <div v-else>
      <!-- show sharepoint login credentials form -->
      <v-card v-if="hasSharepointSettings != null && !hasSharepointSettings">
        <v-container grid-list-xl>
          <!-- <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear> -->
          <span class="subtitle-1 font-weight-bold">{{$t('message.sharepointSettings.credential')}}</span>
          <v-card-text class="pa-0">
            <v-form ref="sharePointLoginForm">
              <v-col cols="12" lg="4" md="4" sm="6">
                  <v-text-field hide-details dense v-model="sharepointObj.username" outlined small :label="$t('message.login.userName')" :rules="$_requiredValidation" required></v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="4" sm="6">
                  <v-text-field hide-details dense v-model="sharepointObj.password" outlined small :label="$t('message.login.password')" type="password" :rules="$_requiredValidation" required></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-btn class="primary mt-3 ml-2" :loading="saveLoading" @click="saveSPCredentials">{{$t('message.common.save')}}</v-btn>
                </v-col>
            </v-form>
          </v-card-text>
        </v-container>
      </v-card>
      <template v-else>
        <!-- Breadcrumbs -->
        <v-row style="min-height: 9vh;">
         <v-fade-transition>
            <v-breadcrumbs class="pa-0 px-3" v-if="breadCrumbItems.length > 1" :items="breadCrumbItems" large>
              <template v-slot:item="{ item }">
                <v-hover v-slot:default="{ hover }">
                  <v-breadcrumbs-item class="custom_breadcrumb_item_style" :class="getBreadCrumbItemIndex(item) !== (breadCrumbItems.length - 1) ? `pointer-hand ${ hover ? 'custom_breadcrumb_item_style_hover' : ''}` : ''" @click="getBreadCrumbItemIndex(item) !== (breadCrumbItems.length - 1) ? navigateToItem(item) : null">
                    <span v-if="getBreadCrumbItemIndex(item) === (breadCrumbItems.length - 1)">
                      <strong>{{ item.text }}</strong>
                    </span>
                    <span v-else>{{ item.text }}</span>
                  </v-breadcrumbs-item>
                </v-hover>
              </template>
              <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
              </template>
            </v-breadcrumbs>
         </v-fade-transition>
        </v-row>
        <v-data-table :loading="loading" dense class="elevation-1" :headers="documentHeaders" :items="listOfDocuments" item-key="_id">
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(document, i) in items" :key="i">
                <td width="5%">
                  <v-speed-dial :v-model="`fab_${i}`" :open-on-hover="true" :right="true" direction="right" transition="slide-y-reverse-transition">
                    <template v-slot:activator>
                      <v-btn size="32" text icon :v-model="`fab_${i}`">
                        <v-icon :size="32" :color="$format.mimeTypeOfDocument(document.mimetype).color">{{ $format.mimeTypeOfDocument(document.mimetype).icon }}</v-icon>
                      </v-btn>
                    </template>
                    <v-btn v-for="(action, index) in document.is_document ? documentActions : folderActions" :key="index" dark @click="action.click(document)" :color="action.color" fab x-small>
                      <v-scale-transition>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">{{ action.icon }}</v-icon>
                          </template>
                          <span>{{ action.tooltip }}</span>
                        </v-tooltip>
                      </v-scale-transition>
                    </v-btn>
                  </v-speed-dial>
                </td>
                <template v-for="(prop, index) in document.properties">
                  <td v-if="prop.name !== 'ContentType'" :key="index">
                    <template v-if="prop.value && prop.value.lookupvalue">
                      {{ prop.value.lookupvalue }}
                    </template>
                    <template v-else-if="dateFieldsForConversion.find(x => x === prop.name)">
                      {{ $format.formatDate(prop.value, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY') }}
                    </template>
                    <template v-else-if="document.is_document">
                      {{ prop.value }}
                    </template>
                    <template v-else>
                      <a @click="loadChildrenItems(document)" class="underline">{{ prop.value }}</a>
                    </template>
                  </td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <template>
          <div style="flex-basis: 20%">
            <v-toolbar flat dense color="grey lighten-3">
              <!-- <v-btn color="success" tile text @click="documentDialog('create')">
                <v-icon>mdi-plus</v-icon> {{$t('message.common.create')}}
              </v-btn> -->
              <v-btn class="ma-2 custom_btn_border text-capitalize" tile outlined text @click="documentDialog('upload')">
                <v-icon left>mdi-file</v-icon> {{$t('message.hse.upload')}}
              </v-btn>
              <v-btn class="ma-2 custom_btn_border text-capitalize" tile outlined text @click="createFolder">
                <v-icon left>mdi-folder</v-icon> {{$t('message.hse.createNew')}}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="info" class="ma-1" tile text @click="navigateToOD(activeFolder)">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
              <v-btn class="ma-1 custom_btn_border text-capitalize" outlined tile text @click="getListOfDocuments(false)">
                <v-icon>mdi-reload</v-icon> {{$t('message.common.refresh')}}
              </v-btn>
            </v-toolbar>
          </div>
        </template>
        <!--Upload or Create Dialog-->
        <v-dialog v-model="uploadDocumentDialog" width="600" persistent>
          <form-template :references.sync="propertiesFormReference" :model="propertyModel.properties" ref="documentReference"></form-template>
        </v-dialog>
        <!--Version Dialog-->
        <v-dialog v-model="versionHistoryDialog" width="1000" persistent>
          <v-card>
            <versions :versionHistory="versionHistory"></versions>
            <v-card-actions>
              <v-flex class="text-center">
                <v-btn color="error" @click="versionHistoryDialog = false">{{$t('message.common.close')}}</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!--Folder rename Dialog-->
        <v-dialog v-model="folderRenameDialog" width="550" persistent>
          <v-card>
            <v-card-title>
              {{ isCreateFolder ? $t('message.hse.createNew') : $t('message.hse.rename') }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-5">
              <v-form ref="renameForm" autocomplete="off">
                <v-text-field hide-details dense v-model="renameModel.name" outlined :label="$t('message.common.name')" :rules="$_requiredValidation" required></v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="renameFolder" :loading="renameLoading">{{$t('message.common.ok')}}</v-btn>
              <v-btn color="error" @click="resetRenameModel">{{$t('message.common.close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </div>
</template>
<script>
import FormTemplate from '@/components/FormTemplate'
import documentHelper from '@/components/documents/document_upload'
import { mapGetters } from 'vuex'
export default {
  props: ['module', 'modelObj'],
  mixins: [documentHelper],
  data () {
    return {
      dialog: false,
      isCreate: false,
      listOfTemplates: [],
      documentHeaders: [],
      listOfFiles: [],
      file: [],
      loading: false,
      uploadDocumentDialog: false,
      propertyModel: {},
      formProps: [],
      listOfProperties: [],
      listOfDocuments: [],
      dynamicFormFields: [],
      dateFieldsForConversion: [],
      versionHistory: [],
      versionHistoryDialog: false,
      documentFormloading: false,
      hasSharepointSettings: null,
      /* for saving sp creds */
      sharepointObj: {},
      MODULE_URL: 'sharepointsetting',
      saveLoading: false,
      fieldsLoading: false,
      renameModel: {},
      folderRenameDialog: false,
      renameLoading: false,
      breadCrumbItems: [],
      removeFromIndex: 0,
      isCreateFolder: false,
      activeFolder: null
    }
  },
  components: {
    FormTemplate,
    'versions': () => import('@/components/documents/Versions')
  },
  computed: {
    ...mapGetters(['formType', 'listOfFields', 'listOfModules', 'userDetails']),
    actionItems () {
      return [{
        icon: '',
        click: ''
      }]
    }
  },
  created () {
    this.getCredential()
  },
  mounted () {
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'sharepoint') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteMsg') })
        this.$store.commit('hideDialog')
        this.getListOfDocuments()
      }
    })
  },
  methods: {
    getCredential () {
      this.$api.execute('get', 'sharepointsetting/get_credential').then(async (response) => {
        if (response && response.data) {
          const data = response.data
          if (data.username && data.password) {
            this.hasSharepointSettings = true
            await this.getProperties()
            this.getListOfDocuments()
          } else {
            this.hasSharepointSettings = false
          }
        }
      })
    },
    renameFolder () {
      if (this.$refs.renameForm.validate()) {
        this.renameLoading = true
        const url = this.isCreateFolder ? 'sharepoint/create_folder' : 'sharepoint/rename'
        const method = this.isCreateFolder ? 'post' : 'put'
        const createFolderObj = { parent_id: this.activeFolder.id, name: this.renameModel.name }
        const model = this.$format.cloneVariable(this.isCreateFolder ? createFolderObj : this.renameModel)
        const text = this.isCreateFolder ? 'message.hse.createdSuccess' : 'message.hse.renameSuccess'
        this.$api.execute(method, url, model)
          .then((response) => {
            this.resetRenameModel()
            this.getListOfDocuments()
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t(text) })
          }).finally(() => {
            this.renameLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    resetRenameModel () {
      this.renameModel = {}
      this.folderRenameDialog = false
      this.$refs.renameForm.reset()
    },
    saveSPCredentials () {
      if (this.$refs.sharePointLoginForm.validate()) {
        this.saveLoading = true
        let model = this.sharepointObj
        this.$api.execute('post', `${this.MODULE_URL}/save_credential`, model)
          .then(async (response) => {
            if (response && response.data) {
              const data = response.data
              if (data.username && data.password) {
                this.hasSharepointSettings = true
                await this.getProperties()
                this.getListOfDocuments()
              } else this.hasSharepointSettings = false
            }
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    async getProperties () {
      this.fieldsLoading = true
      await this.$api.execute('get', 'sharepoint/get_selected_fields').then((response) => {
        if (response && response.data) {
          const data = response.data
          this.documentHeaders = []
          let listOfFields = this.$format.cloneVariable(data)
          let result = listOfFields.find(x => x.name === 'ContentType')
          if (!result) this.documentHeaders.push({ text: 'Type', value: 'ContentType' })
          listOfFields.forEach(element => {
            this.documentHeaders.push({ text: element.name !== 'ContentType' ? element.title : 'Type', value: element.name })
          })
          let avaliableProps = listOfFields || []
          this.dynamicFormFields = this.$format.cloneVariable(avaliableProps)
          avaliableProps.unshift({ title: 'Type' })
          this.listOfProperties = avaliableProps
          this.prepareFieldsForProperties()
        }
      }).finally(() => {
        this.fieldsLoading = false
      })
    },
    getListOfDocuments (isForceLoad) {
      this.loading = true
      if (!isForceLoad && this.breadCrumbItems.length > 1) {
        this.loadChildrenItems(this.breadCrumbItems[this.breadCrumbItems.length - 1], true)
      } else {
        let url = this.module === 'project' ? `sharepoint/get_project_documents/${this.modelObj.id}?name=${this.modelObj.name}` : `sharepoint/get_company_documents/${this.modelObj.id}?name=${this.modelObj.name}`
        this.$api.execute('get', url).then((response) => {
          const { folder, documents } = response.data
          documents.forEach(element => {
            if (!element.is_document) element.mimetype = 'folder'
          })
          this.listOfDocuments = documents
          folder.path = folder.weburl
          this.activeFolder = this.$format.cloneVariable(folder)
          if (this.breadCrumbItems.length > 1) {
            this.breadCrumbItems.splice(1, this.breadCrumbItems.length)
          } else {
            const breadcrumbItem = { id: this.activeFolder.id, text: this.modelObj.name, isRoot: true, path: folder.path }
            const obj = this.breadCrumbItems.find(x => x.id === this.activeFolder.id)
            if (obj === null || obj === undefined) this.breadCrumbItems.push(breadcrumbItem)
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    setHeadersAndProps () {
      if (this.listOfFields.length > 0) {
        this.documentHeaders = []
        let listOfFields = this.$format.cloneVariable(this.listOfFields)
        let result = listOfFields.find(x => x.name === 'ContentType')
        if (!result) this.documentHeaders.push({ text: 'Type', value: 'ContentType' })
        listOfFields.forEach(element => {
          this.documentHeaders.push({ text: element.name !== 'ContentType' ? element.title : 'Type', value: element.name })
        })
        let avaliableProps = listOfFields || []
        this.dynamicFormFields = this.$format.cloneVariable(avaliableProps)
        avaliableProps.unshift({ title: 'Type' })
        this.listOfProperties = avaliableProps
        this.prepareFieldsForProperties()
      }
    },
    updateDocumentMeta () {
      this.documentFormloading = true
      this.propertyModel.parent_id = this.activeFolder.id
      let model = this.$format.cloneVariable(this.propertyModel.properties)
      model = Object.assign({ ...model }, { parent_id: this.activeFolder.id })
      let transformData = { date: { list: this.dateFieldsForConversion, from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
      model = this.$format.formatModel(model, transformData)
      this.$api.execute('put', `sharepoint/update_doc_meta_data/${this.propertyModel.id}`, model)
        .finally(() => {
          this.documentFormloading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
          this.closeDocumentDialogHandler()
          this.getListOfDocuments()
        })
    },
    uploadDocumentHandler () {
      if (this.$refs.documentReference.$refs.validateForm.validate()) {
        this.documentFormloading = true
        let props = this.propertyModel.properties
        let transformData = { date: { list: this.dateFieldsForConversion, from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
        let model = this.$format.formatModel(props, transformData)
        let formData = new FormData()
        formData.append('parent_id', this.activeFolder.id)
        let files = props.files
        files.forEach(file => {
          formData.append(file.name, file)
        })
        for (let key in model) {
          if (key !== 'files') formData.append(key, model[key] || null)
        }
        this.$api.execute('post', `sharepoint/upload`, formData).finally(() => {
          this.documentFormloading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.uploadedSuccess') })
          this.closeDocumentDialogHandler()
          this.getListOfDocuments()
        })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    openDialogHanlder (type) {
      if (type === 'create') this.isCreate = true
      this.dialog = true
    },
    closeDialogHandler () {
      this.file = []
      this.isCreate = false
      this.dialog = false
    },
    loadChildrenItems (item, dontAdd) { // dont add item to breadcrumb if dontadd is true
      this.activeFolder = this.$format.cloneVariable(item)
      const breadcrumbItem = { id: item.id, text: item.name, path: item.path }
      this.loading = true
      this.$api.execute('get', `sharepoint/get_allchidren_items?id=${item.id}`).then((response) => {
        const documents = response.data
        documents.forEach(element => {
          if (!element.is_document) element.mimetype = 'folder'
        })
        // add folder to breadcrumb
        if (this.removeFromIndex !== 0) {
          this.breadCrumbItems.splice(this.removeFromIndex, this.breadCrumbItems.length)
          this.removeFromIndex = 0
        }
        if (!dontAdd) this.breadCrumbItems.push(breadcrumbItem)
        this.listOfDocuments = documents
      }).finally(() => {
        this.loading = false
      })
    },
    navigateToItem (item) {
      this.removeFromIndex = this.getBreadCrumbItemIndex(item)
      if (item.isRoot) {
        this.getListOfDocuments(true) // do force load to not check conditon of breadcrumb active item
      } else {
        this.loadChildrenItems({ id: item.id, name: item.text })
      }
    },
    getBreadCrumbItemIndex (item) {
      return this.breadCrumbItems.indexOf(item)
    },
    createFolder () {
      this.isCreateFolder = true
      this.folderRenameDialog = true
    }
  }
}
</script>
<style>
.pointer-hand {
  cursor: pointer !important;
}
.custom_breadcrumb_item_style {
 padding: 0.5rem;
 border-radius: 3px;
}
.custom_breadcrumb_item_style_hover {
  background: #e0e0e0;
}
.custom_btn_border {
  border: 2px solid #6f9b9a !important;
  color: #0a5e58;
}
</style>
